// (c) chaehongee. Confidential and proprietary.

export type SessionStreamHandle = { cancel: () => void }

const streamsBySessionId: Record<string, SessionStreamHandle> = {}

export function registerSessionStream(sessionId: string, handle: SessionStreamHandle): void {
    if (!sessionId) return
    const prev = streamsBySessionId[sessionId]
    if (prev && prev !== handle) {
        try { prev.cancel() } catch { }
    }
    streamsBySessionId[sessionId] = handle
}

export function releaseSessionStream(sessionId: string, handle: SessionStreamHandle): void {
    if (!sessionId) return
    if (streamsBySessionId[sessionId] === handle) {
        delete streamsBySessionId[sessionId]
    }
}

export function cancelSessionStream(sessionId: string): void {
    if (!sessionId) return
    const handle = streamsBySessionId[sessionId]
    if (!handle) return
    try { handle.cancel() } catch { }
    delete streamsBySessionId[sessionId]
}

export function cancelAllSessionStreams(): void {
    for (const sessionId of Object.keys(streamsBySessionId)) {
        cancelSessionStream(sessionId)
    }
}

